import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from "reactstrap";

export default class ValidationButton extends React.Component {
  tooltipRef = React.createRef();

  static propTypes = {
    buttonText:   PropTypes.string,
    errorMessage: PropTypes.string,
    buttonAction: PropTypes.func,
    className:    PropTypes.string,
    valid:        PropTypes.bool
  };

  static defaultProps = {
    valid: true
  };

  state = {
    tooltipOpen: false
  };

  toggleTooltip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  hoverStyle() {
    if (this.props.errorMessage) {
      return { pointerEvents: "none" };
    } else {
      return {};
    }
  }

  render() {
    const { valid, errorMessage, className, buttonAction, buttonText } = this.props;
    const disabled = !valid || !!errorMessage;

    const spanStyle = {
      padding: "0"
    };

    return (
      <React.Fragment>
        <div className="btn" style={spanStyle} ref={this.tooltipRef} onMouseEnter={this.toggleTooltip} onMouseLeave={this.toggleTooltip}>
          <button
            type="button"
            className={className}
            disabled={disabled}
            onClick={buttonAction}
            style={this.hoverStyle()}>
            {buttonText}
          </button>
        </div>

        { errorMessage &&
          <Tooltip data-selector="btn-invalid" placement="right" isOpen={this.state.tooltipOpen} target={this.tooltipRef} toggle={this.toggleTooltip}>
            {errorMessage}
          </Tooltip>
        }

      </React.Fragment>
    );
  }
}
